module.exports = __webpack_public_path__ + "img/ba.dfb161c5.svg";